import React from 'react';
import ReorderableList from './reorderable-list';
import TagSelector from './tag-selector';
import ProductSelector from './product-selector';
import TagCreationForm from './tag-creation-form';

interface TagItem {
  id: string;
  displayName: string;
  description?: string;
}

interface ReorderableTagSectionProps {
  items: TagItem[];
  onReorder: (fromIndex: number, toIndex: number) => void;
  onRemove: (itemId: string) => void;
  onSelectExisting: (value: string) => void;
  onSelectProduct?: (value: string) => void;
  isProduct?: boolean;
  label: string;
  placeholder: string;
  emptyMessage: string;
  
  // Tag creation form props
  isAddingNewTag: boolean;
  tagName: string;
  tagDescription: string;
  onTagNameChange: (value: string) => void;
  onTagDescriptionChange: (value: string) => void;
  onAddTag: () => void;
  onCancelTagCreation: () => void;
  addingProduct?: boolean;
}

const ReorderableTagSection: React.FC<ReorderableTagSectionProps> = ({
  items,
  onReorder,
  onRemove,
  onSelectExisting,
  onSelectProduct,
  isProduct = false,
  label,
  placeholder,
  emptyMessage,
  isAddingNewTag,
  tagName,
  tagDescription,
  onTagNameChange,
  onTagDescriptionChange,
  onAddTag,
  onCancelTagCreation,
  addingProduct = false
}) => {
  return (
    <>
      <ReorderableList
        items={items}
        onReorder={onReorder}
        onRemove={onRemove}
        title=""
        emptyMessage={emptyMessage}
      />
      
      {/* Selector for existing items */}
      {isProduct && onSelectProduct ? (
        <ProductSelector
          selectedProducts={items.map(item => item.id)}
          onSelectProduct={onSelectProduct}
          label={label}
          placeholder={placeholder}
        />
      ) : (
        <TagSelector
          selectedTags={items.map(item => item.id)}
          onSelectTag={onSelectExisting}
          isProduct={isProduct}
          label={label}
          placeholder={placeholder}
        />
      )}
      
      {/* Tag creation form */}
      <TagCreationForm
        isVisible={isAddingNewTag}
        tagName={tagName}
        tagDescription={tagDescription}
        onTagNameChange={onTagNameChange}
        onTagDescriptionChange={onTagDescriptionChange}
        onAddTag={onAddTag}
        onCancel={onCancelTagCreation}
        tagType={isProduct ? 'product' : 'tag'}
        isProduct={addingProduct}
      />
    </>
  );
};

export default ReorderableTagSection;
